module.exports = __webpack_public_path__ + "img/icon_evalute@3x.20c35e00.png";